VjsAdmin.LicenseSearch = (function () {
    const $vjsTable = $('#vjs-results-table');
    const $jrTable = $('#jr-results-table');
    const $cpTable = $('#cp-results-table');

    let platformsQueried = 0;

    const reportsTableOptions = {
        ...VjsTable.tableDefaults(),
        showColumns: true,
        idField: 'license_id',
        search: false,
        sortName: 'license_id',
        toolbarAlign: 'left',
        url: Slim.Router.pathFor('license_search.json'),
        formatNoMatches() {
            return `No matching licenses found on ${this.platform_name}!`;
        },
        onLoadSuccess(data) {
            VjsTable.tableDefaults().onLoadSuccess.call(this, data);
            $(this.results_container_element).find('.alert').remove();
            $('#result-list-container').fadeIn();
            $(this.results_container_element).find('.results-container').fadeIn();
            platformsQueried--;
            if (platformsQueried <= 0) {
                $('#run-report').prop('disabled', false).html('Search Again');
                $('#ajax-progress-indicator').fadeOut();
            }
        },
        updateUrl() {
            const queryParams = {};
            if ($('#search-term').val()) {
                queryParams.search_term = $('#search-term').val();
            }
            if ($('#search-status').val() && $('#search-status').val() !== 'active') {
                queryParams.search_status = $('#search-status').val();
            }
            if ($('#search-state').val() && $('#search-state').val() !== '') {
                queryParams.search_state = $('#search-state').val();
            }
            if ($('#search-account-manager').val() && $('#search-account-manager').val() !== 'all') {
                queryParams.search_account_manager = $('#search-account-manager').val();
            }
            VjsTable.tableDefaults().updateUrl.call(this, queryParams);
        },
        onLoadError(status) {
            if (+status === 500 || +status === 404) {
                // eslint-disable-next-line no-new, new-cap
                new PNotify.error({
                    title: 'Load Error',
                    text: `${this.platform_name} cannot be reached!`,
                    icon: 'fa fa-exclamation-triangle',
                    type: 'error',
                });
            }
            $(this.results_count_element).html('(<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>)');
            $(this.results_container_element).find('.results-container').fadeOut();
            $(this.results_container_element).find('.alert').remove();
            $(this.results_container_element).prepend(
                `<div class="alert alert-danger" role="alert"><div class="wrapper"><div class="icon"><i class="fa fa-exclamation-triangle" aria-hidden="true"></i></div> <!-- /.icon --><div class="message">An error occurred while retrieving users from ${this.platform_name}!</div> <!-- /.message --></div> <!-- /.wrapper --></div> <!-- /.alert -->`,
            );
            platformsQueried--;
            if (platformsQueried <= 0) {
                $('#run-report').prop('disabled', false).html('Search Again');
                $('#ajax-progress-indicator').fadeOut();
            }
        },
        queryParams(params) {
            const myParams = VjsTable.tableDefaults().queryParams.call(this, params);
            myParams.platform_id = this.platform_id;
            myParams.search_term = $('#search-term').val().trim();
            const selectedStatus = $('#search-status option:selected').val();

            myParams.active = null;
            myParams.expire_in_days = null;
            myParams.activated_in_days = null;

            switch (selectedStatus) {
                case 'all':
                    myParams.active = null;
                    break;
                case 'active':
                    myParams.active = 1;
                    break;
                case 'expired':
                    myParams.active = 0;
                    break;
                case 'expire-30':
                    myParams.active = 1;
                    myParams.expire_in_days = 30;
                    break;
                case 'expire-60':
                    myParams.active = 1;
                    myParams.expire_in_days = 60;
                    break;
                case 'expire-90':
                    myParams.active = 1;
                    myParams.expire_in_days = 90;
                    break;
                case 'activate-30':
                    myParams.active = 1;
                    myParams.activated_in_days = 30;
                    break;
                case 'activate-60':
                    myParams.active = 1;
                    myParams.activated_in_days = 60;
                    break;
                case 'activate-90':
                    myParams.active = 1;
                    myParams.activated_in_days = 90;
                    break;
                case 'exceeding-user-limit':
                    myParams.active = 1;
                    myParams.exceeding_user_limit = 1;
                    break;
                case 'within-user-limit':
                    myParams.active = 1;
                    myParams.exceeding_user_limit = 0;
                    break;
                default:
                    break;
            }

            myParams.state_code = $('#search-state option:selected').val();
            myParams.manager = $('#search-account-manager option:selected').val();
            return myParams;
        },
        responseHandler(res) {
            const formattedResult = {};
            formattedResult.total = res.meta.total;
            formattedResult.rows = res.data;
            $(this.results_count_element).html(`(${formattedResult.total})`);

            const platformId = this.platform_id;

            $(formattedResult.rows).each((i, result) => {
                // we're getting a UTC date from the DB... need to convert it to the users timezone...?
                const dateFormat = 'MM/DD/YYYY';
                const row = VjsAdmin.convertDateRow(result, dateFormat);

                row.is_active = row.active;

                if (+row.active === 0) {
                    row.active = '<i class="fa fa-times text-danger" aria-hidden="true"></i>';
                } else {
                    row.active = '<i class="fa fa-check text-success" aria-hidden="true"></i>';
                }

                if (+row.user_count > +row.user_account_limit) {
                    row.user_account_limit += '<i class="fa fa-exclamation-triangle text-danger" aria-hidden="true"></i>';
                }

                if (VjsAdmin.hasPermission('platforms.districts.view')) {
                    const districturl = Slim.Router.pathFor('platforms.districts.view', {
                        platform_id: platformId,
                        district_joint_guid: row.district_joint_guid,
                    });
                    row.district_name = `<a href="${districturl}" class="">${row.district_name}</a>`;
                }

                if (VjsAdmin.hasPermission('platforms.districts.licenses.view')) {
                    const licensesUrl = Slim.Router.pathFor('platforms.districts.licenses.view', {
                        platform_id: platformId,
                        district_joint_guid: row.district_joint_guid,
                        license_id: row.license_id,
                    });
                    row.license_name = `<a href="${licensesUrl}" class="">${row.license_name}</a>`;
                }

                if (VjsAdmin.hasPermission('platforms.districts.licenses.users.list')) {
                    const usersUrl = Slim.Router.pathFor('platforms.districts.licenses.users.list', {
                        platform_id: platformId,
                        district_joint_guid: row.district_joint_guid,
                        license_id: row.license_id,
                    });
                    row.user_count = `<a href="${usersUrl}?search_roles=users">${row.user_count}</a>`;
                    row.admin_count = `<a href="${usersUrl}?search_roles=admins">${row.admin_count}</a>`;
                }

                if (VjsAdmin.hasPermission('platforms.districts.licenses.groups.list')) {
                    const groupsUrl = Slim.Router.pathFor('platforms.districts.licenses.groups.list', {
                        platform_id: platformId,
                        district_joint_guid: row.district_joint_guid,
                        license_id: row.license_id,
                    });
                    row.group_count = `<a href="${groupsUrl}">${row.group_count}</a>`;
                }

                const diffHours = moment().diff(moment(row.date_created).utc(), 'hours');

                if (diffHours < 24) {
                    row.license_name += ' <span class="badge badge-pill badge-success new-badge">NEW</span>';
                }
            });

            return formattedResult;
        },
        columns: [
            {
                title: 'District ID',
                field: 'district_id',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'District',
                field: 'district_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'License ID',
                field: 'license_id',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'License',
                field: 'license_name',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'City',
                field: 'city',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: 'State',
                field: 'state_code',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Zip',
                field: 'zipcode',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Created',
                field: 'date_created',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Activation',
                field: 'activation_date',
                align: 'left',
                valign: 'middle',
                visible: false,
                sortable: true,
            },
            {
                title: '<i class="fa fa-calendar" aria-hidden="true"></i> Expiration',
                field: 'expiration_date',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'User Limit',
                field: 'user_account_limit',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: '<i class="fa fa-hashtag" aria-hidden="true"></i> Users',
                field: 'user_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: '<i class="fa fa-hashtag" aria-hidden="true"></i> Admins',
                field: 'admin_count',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
            {
                title: 'Rostering',
                field: 'rostering_type',
                align: 'left',
                valign: 'middle',
                sortable: true,
            },
        ],
    };

    const init = function () {
        $('#search-term').val($.urlParam('search_term') ? decodeURIComponent($.urlParam('search_term')) : null);
        $(`#search-status option[value="${$.urlParam('search_status') ? decodeURIComponent($.urlParam('search_status')) : null}"]`).attr(
            'selected',
            true,
        );
        $(`#search-state option[value="${$.urlParam('search_state') ? decodeURIComponent($.urlParam('search_state')) : null}"]`).attr(
            'selected',
            true,
        );
        $(
            `#search-account-manager option[value="${
                $.urlParam('search_account_manager') ? decodeURIComponent($.urlParam('search_account_manager')) : null
            }"]`,
        ).attr('selected', true);

        $('#report-form').on('change', 'input, select', () => {
            $('#run-report').prop('disabled', false).html('Search Licenses');
        });

        $('#report-form').on('submit', (event) => {
            event.preventDefault();
            $('#ajax-progress-indicator').fadeIn();

            $('#run-report').prop('disabled', true).html('Searching... <i class="fa fa-spinner fa-spin fa-fw"></i>');
            $('#vjs_num_results').html('(<i class="fa fa-spinner fa-spin fa-fw"></i>)');
            $('#jr_num_results').html('(<i class="fa fa-spinner fa-spin fa-fw"></i>)');
            $('#cp_num_results').html('(<i class="fa fa-spinner fa-spin fa-fw"></i>)');

            platformsQueried++;
            platformsQueried++;

            // get vjs license data
            const vjsTableOptions = {
                ...reportsTableOptions,
                table: '#vjs-results-table',
                platform_id: 1,
                platform_name: 'VirtualJobShadow.com',
                results_count_element: '#vjs_num_results',
                results_container_element: '#vjs-results',
                toolbar: '#vjs-report-toolbar',
            };
            $vjsTable.bootstrapTable('destroy');
            $vjsTable.bootstrapTable(vjsTableOptions);

            // get jr license data
            const jrTableOptions = {
                ...reportsTableOptions,
                table: '#jr-results-table',
                platform_id: 2,
                platform_name: 'VJSJunior.com',
                results_count_element: '#jr_num_results',
                results_container_element: '#jr-results',
                toolbar: '#jr-report-toolbar',
            };

            $jrTable.bootstrapTable('destroy');
            $jrTable.bootstrapTable(jrTableOptions);

            // get CP license data
            const cpTableOptions = {
                ...reportsTableOptions,
                table: '#cp-results-table',
                platform_id: 4,
                platform_name: 'Course Planner',
                results_count_element: '#cp_num_results',
                results_container_element: '#cp-results',
                toolbar: '#cp-report-toolbar',
            };

            $cpTable.bootstrapTable('destroy');
            $cpTable.bootstrapTable(cpTableOptions);

            reportsTableOptions.updateUrl();
            return false;
        });

        $('.app-content').on('click', '#vjs-export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = $vjsTable.bootstrapTable('getOptions').queryParams.call($vjsTable.bootstrapTable('getOptions'));
            const visibleColumns = $vjsTable.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            if ($('#include-usage-stats').prop('checked')) {
                exportColumns.usage_date_range = 'Usage Date Range';
            }
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace('<i class="fa fa-hashtag" aria-hidden="true"></i>', '#')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        $('.app-content').on('click', '#jr-export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = $jrTable.bootstrapTable('getOptions').queryParams.call($jrTable.bootstrapTable('getOptions'));
            const visibleColumns = $jrTable.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace('<i class="fa fa-hashtag" aria-hidden="true"></i>', '#')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        $('.app-content').on('click', '#cp-export-form', function (e) {
            e.preventDefault();
            const href = $(this).attr('href');
            const params = $cpTable.bootstrapTable('getOptions').queryParams.call($cpTable.bootstrapTable('getOptions'));
            const visibleColumns = $cpTable.bootstrapTable('getVisibleColumns');
            const exportColumns = {};
            $.each(visibleColumns, (i, column) => {
                if (column.field !== 'actions') {
                    exportColumns[column.field] = column.title
                        .replace('<i class="fa fa-calendar" aria-hidden="true"></i>', 'Date')
                        .replace('<i class="fa fa-hashtag" aria-hidden="true"></i>', '#')
                        .replace(/<br>/g, ' ');
                }
            });
            params.columns = exportColumns;
            window.open(`${href}?${$.param(params)}`, 'Export');
        });

        if (
            $.urlParam('search_term')
            || $.urlParam('search_status')
            || $.urlParam('search_state')
            || $.urlParam('search_account_manager')
        ) {
            $('#report-form').trigger('submit');
        }
    };

    return {
        init,
    };
}());
